@if (loadStatus === 'FAILURE') {
  <app-alert type="danger">
    Sorry, we had trouble fetching your current payment information. Please try
    again later.
  </app-alert>
}

@if (loadStatus === 'LOADING') {
  <app-loading></app-loading>
}

<div
  [formGroup]="form"
  [hidden]="loadStatus !== 'SUCCESS'"
  class="payment-form"
>
  @for (method of paymentMethods; track method) {
    <div class="form-check">
      <input
        data-dd-action-name="payment.payment-method-radio"
        id="payment-{{ method.id }}"
        type="radio"
        class="form-check-input"
        formControlName="paymentMethod"
        name="paymentMethod"
        [value]="method.id"
      />
      <label
        for="payment-{{ method.id }}"
        class="form-check-label Checkbox-item"
      >
        <div class="horizontal-wrap align-items-start">
          @if (method.type === 'Card') {
            <div class="me-2">
              @switch (method.card.brand) {
                @case ('AmericanExpress') {
                  American Express
                }
                @case ('MasterCard') {
                  Mastercard
                }
                @default {
                  {{ method.card.brand }}
                }
              }

              <p class="mt-1">
                @switch (method.card.brand) {
                  @case ('AmericanExpress') {
                    **** ****** *{{ method.card.last4 }}
                  }
                  @default {
                    **** **** **** {{ method.card.last4 }}
                  }
                }

                <br />
                Expiry: {{ method.card.expMonth }}/{{ method.card.expYear }}
              </p>
            </div>
          }
        </div>
        @if (method.isPrimary) {
          <app-alert type="info">
            This is your current payment method. To change your payment method,
            either create or select one and then click 'Save'.
          </app-alert>
        }
      </label>
    </div>
  }

  <div class="form-check">
    <input
      data-dd-action-name="payment.new-payment-method-radio"
      id="payment-new"
      type="radio"
      class="form-check-input"
      formControlName="paymentMethod"
      name="paymentMethod"
      value=""
    />
    <label for="payment-new" class="form-check-label Checkbox-item pb-1">
      Add New
    </label>

    <div class="Checkbox-expander">
      <app-form-control margin="small">
        <app-form-label>Card Number</app-form-label>
        <label
          #cardNumber
          class="m-0"
          id="{{ parentComponent }}-cardNumber"
        ></label>
        <div class="invalid-feedback">{{ cardNumberError }}</div>
      </app-form-control>

      <app-form-control size="small" margin="small">
        <app-form-label>Card Expiry</app-form-label>
        <label
          #cardExpiry
          class="m-0"
          id="{{ parentComponent }}-cardExpiry"
        ></label>
        <div class="invalid-feedback">{{ cardExpiryError }}</div>
      </app-form-control>

      <app-form-control size="small">
        <app-form-label>
          <abbr title="Card Verification Code">CVC</abbr>
        </app-form-label>
        <label #cardCvc class="m-0" id="{{ parentComponent }}-cardCvc"></label>
        <div class="invalid-feedback">{{ cardCvcError }}</div>
      </app-form-control>
    </div>
  </div>
  <app-form-control [columnLayout]="true" class="d-block w-50">
    <app-form-label> Country (for tax purposes) </app-form-label>
    <select
      data-dd-action-name="payment.country-select"
      class="form-select"
      formControlName="countryId"
      [class.is-invalid]="
        form.controls.countryId.touched && form.controls.countryId.invalid
      "
    >
      @for (country of countries; track country) {
        <option [ngValue]="country.id">
          {{ country.name }}
        </option>
      }
    </select>
  </app-form-control>
</div>

@if (errorMessages.length > 0 || unknownError) {
  <app-alert type="danger">
    <p>
      <strong>
        Sorry, we had some trouble saving your payment info. Please check your
        info and try again.
      </strong>
    </p>
    <ul>
      @for (errorMessage of errorMessages; track errorMessage) {
        <li>
          {{ errorMessage }}
        </li>
      }
    </ul>
  </app-alert>
}
